import React from 'react';

const StatCard = ({ icon: Icon, label, value, tint = 'emerald' }) => {
  const testId = `stat-${label.toLowerCase().replace(/\s+/g, '-')}`;
  return (
    <div data-testid={testId} className="bg-white rounded-xl p-5 border border-slate-200 shadow-sm">
      <div className="flex items-center justify-between mb-2">
        <div className={`w-10 h-10 rounded-lg bg-${tint}-100 flex items-center justify-center`}>
          <Icon className={`w-5 h-5 text-${tint}-600`} />
        </div>
      </div>
      <div className="text-3xl font-bold text-slate-900">{value}</div>
      <div className="text-sm text-slate-500">{label}</div>
    </div>
  );
};

export default StatCard;
